import { Observable } from 'rxjs'
import AxiosSubscriber from '../../factory/AxiosSubscriber'

export class CancelScheduleUpgradeAPI {
  constructor() {
    this.subscription = null
  }

  subscribe(next, complete, error) {
    const token = localStorage.getItem('token')

    const httpConfig = {
      url: '/package/cancel-upgrade',
      method: 'put',
      headers: {
        accept: 'application/json',
        'Content-Type': `application/json`,
        Authorization: `Bearer ${token}`,
      },
    }

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig)
    })

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error,
    })
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe()
    }
  }
}
